export default "__VITE_ASSET__BGWJU6R3__"